import { MissingVarError } from '@execonline-inc/environment';
import { Cable } from 'actioncable';

export interface CableInitializationError {
  kind: 'cable-initialization-error';
  key: string;
}

export type WebsocketInitializationError = MissingVarError | CableInitializationError;

interface Loading {
  kind: 'loading';
}

interface Initialize {
  kind: 'initialize';
}

interface Ready {
  kind: 'ready';
  cable: Cable;
  correlationId: string;
}

interface Error {
  kind: 'error';
  message: string;
}

export type State = Initialize | Loading | Ready | Error;

export const errorMessage = (error: WebsocketInitializationError) => {
  switch (error.kind) {
    case 'missing-var-error':
      return `Unable to initialize websockets: Missing environment variable ${error.key}`;
    case 'cable-initialization-error':
      return `Websocket initialization error: ${error.key}`;
  }
};

export const initialize = (): Initialize => ({
  kind: 'initialize',
});

export const loading = (): Loading => ({
  kind: 'loading',
});

export const ready = (cable: Cable, correlationId: string): Ready => ({
  kind: 'ready',
  cable,
  correlationId,
});

export const error = (message: string): Error => ({
  kind: 'error',
  message,
});
